import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _category = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    headerImage: '_image',
    headerImageOverlayColor: '_colorComponent',
    headerBackgroundColor: '_colorComponent',
    headerTextColor: '_colorComponent',
};
var _categoryRequest = {};
var _categoryResponse = { category: '_category' };
var _categorySlugRequest = {};
var _colorComponent = { opacity: 'google.protobuf.DoubleValue' };
var _createCategoryRequest = { category: '_category' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = { category: '_category' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _markAllPostsAsReadRequest = {};
var _markAllPostsAsReadResponse = {};
var _markCategoryReadRequest = {};
var _markCategoryReadResponse = {};
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = { categories: '_category' };
var _subscribeContactToCategoryRequest = {};
var _subscribeContactToCategoryResponse = {};
var _unsubscribeContactFromCategoryRequest = {};
var _unsubscribeContactFromCategoryResponse = {};
var _updateCategoryRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    category: '_category',
};
function resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/_internal/communities',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/communities-forum-app',
                destPath: '',
            },
            {
                srcPath: '/communities',
                destPath: '',
            },
            {
                srcPath: '/_api/',
                destPath: '/_api',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/forum/v1/draft-posts',
                destPath: '/v1/draft-posts',
            },
            {
                srcPath: '/forum/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/forum/v1/comments',
                destPath: '/v1/comments',
            },
            {
                srcPath: '/forum/v1/posts',
                destPath: '/v1/posts',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities-forum-app',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/forums/this',
                destPath: '/_api/forums/this',
            },
            {
                srcPath: '/_api/communities/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities/posts',
                destPath: '/_api/posts',
            },
            {
                srcPath: '/_api/communities/platformized/v1/draft-posts',
                destPath: '/v1/draft-posts',
            },
            {
                srcPath: '/_api/communities/platformized/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/communities/platformized/v1/comments',
                destPath: '/v1/comments',
            },
            {
                srcPath: '/_api/communities/platformized/v1/posts',
                destPath: '/v1/posts',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
            {
                srcPath: '/_api/communities/platformized/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'notifications-app.wixapps.net': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities',
                destPath: '/_api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/forum/v1/notifications',
                destPath: '/v1/notifications',
            },
            {
                srcPath: '/forum/v1/draft-posts',
                destPath: '/v1/draft-posts',
            },
            {
                srcPath: '/forum/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/forum/v1/comments',
                destPath: '/v1/comments',
            },
            {
                srcPath: '/forum/v1/posts',
                destPath: '/v1/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns a single category by ID. */
export function getCategory(payload) {
    var _a = serializer(_categoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_categoryResponse, {
        _category: _category,
        _colorComponent: _colorComponent,
        _image: _image,
    }).fromJSON;
    function __getCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.GetCategory',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({ protoPath: '/v1/categories/{categoryId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategory.fromReq = fromReq;
    __getCategory.__isAmbassador = true;
    return __getCategory;
}
/** Returns a single category by URL slug. */
export function getCategoryBySlug(payload) {
    var _a = serializer(_categorySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_categoryResponse, {
        _category: _category,
        _colorComponent: _colorComponent,
        _image: _image,
    }).fromJSON;
    function __getCategoryBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.GetCategoryBySlug',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({ protoPath: '/v1/categories/slugs/{slug}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategoryBySlug.fromReq = fromReq;
    __getCategoryBySlug.__isAmbassador = true;
    return __getCategoryBySlug;
}
/**
 * Retrieves a list of categories, given the provided paging, filtering, and sorting.
 *
 * Query Categories runs with these defaults, which you can override:
 *
 * - `paging.limit` is `10`
 * - `paging.offset` is `0`
 *
 * For field support for filters and sorting,
 * see [Categories: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-forum/wix-forum/filter-and-sort#category-api-supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {
        _category: _category,
        _colorComponent: _colorComponent,
        _image: _image,
    }).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.QueryCategories',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({ protoPath: '/v1/categories/query', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Marks category as read for identity who made a request. */
export function markCategoryRead(payload) {
    var _a = serializer(_markCategoryReadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markCategoryReadResponse, {}).fromJSON;
    function __markCategoryRead(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.MarkCategoryRead',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({
                protoPath: '/v1/categories/{categoryId}/mark-read',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markCategoryRead.fromReq = fromReq;
    __markCategoryRead.__isAmbassador = true;
    return __markCategoryRead;
}
/** Marks all category posts as read for identity who made a request. If categoryId is not provided it marks all posts in the forum as read */
export function markAllPostsAsRead(payload) {
    var _a = serializer(_markAllPostsAsReadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAllPostsAsReadResponse, {}).fromJSON;
    function __markAllPostsAsRead(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.MarkAllPostsAsRead',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({
                protoPath: '/v1/categories/mark-posts-read',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAllPostsAsRead.fromReq = fromReq;
    __markAllPostsAsRead.__isAmbassador = true;
    return __markAllPostsAsRead;
}
/** Creates a new category. */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, { _category: _category, _colorComponent: _colorComponent, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_categoryResponse, {
        _category: _category,
        _colorComponent: _colorComponent,
        _image: _image,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.CreateCategory',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({ protoPath: '/v1/categories', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Updates a category's fields according to `fieldMask`. */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, { _category: _category, _colorComponent: _colorComponent, _image: _image }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_categoryResponse, {
        _category: _category,
        _colorComponent: _colorComponent,
        _image: _image,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.UpdateCategory',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({ protoPath: '/v1/categories/{categoryId}', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/** Deletes a category (only if it is not last category). */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {
        _category: _category,
        _colorComponent: _colorComponent,
        _image: _image,
    }).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.DeleteCategory',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({ protoPath: '/v1/categories/{categoryId}', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
/**
 * Subscribes a contact to a specific forum category.
 *
 * By default a contact isn't subscribed to any forum categories.
 *
 * By subscribing a contact to a category, the contact receives notifications for that category.
 *
 * If `contactId` is not provided, it is implicitly resolved from the caller's context.
 */
export function subscribeContactToCategory(payload) {
    var _a = serializer(_subscribeContactToCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_subscribeContactToCategoryResponse, {}).fromJSON;
    function __subscribeContactToCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'PUT',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.SubscribeContactToCategory',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({
                protoPath: '/v1/categories/{categoryId}/subscription',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __subscribeContactToCategory.fromReq = fromReq;
    __subscribeContactToCategory.__isAmbassador = true;
    return __subscribeContactToCategory;
}
/**
 * Unsubscribes a contact from a specific forum category.
 *
 * By default a contact isn't subscribed to any forum categories.
 *
 * By unsubscribing a contact from a category, the contact won’t receive notifications for that category.
 *
 * If `contactId` is not provided, it is implicitly resolved from the caller's context.
 */
export function unsubscribeContactFromCategory(payload) {
    var _a = serializer(_unsubscribeContactFromCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unsubscribeContactFromCategoryResponse, {}).fromJSON;
    function __unsubscribeContactFromCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forum.v1.category',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.forum.api.CategoryManagementService.UnsubscribeContactFromCategory',
            url: resolveComWixpressNpmCommunitiesForumApiCategoryManagementServiceUrl({
                protoPath: '/v1/categories/{categoryId}/subscription',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unsubscribeContactFromCategory.fromReq = fromReq;
    __unsubscribeContactFromCategory.__isAmbassador = true;
    return __unsubscribeContactFromCategory;
}
//# sourceMappingURL=http.impl.js.map